import React from 'react';
import './SkeletonBox.css';

const SkeletonBox = ({ width = '100%', height = '16px', radius = '8px', className = '' }) => (
  <div className={`skeleton-box ${className}`} style={{ width, height, borderRadius: radius }} />
);

export default SkeletonBox;
